import { Component, ContentChildren, Input, QueryList } from '@angular/core';
import { TabContentDirective } from '../../directives/tab-content.directive';
import { NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'shared-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.css'],
  standalone: true,
  imports: [NgTemplateOutlet],
})
export class TabsComponent {
  @Input({ required: true }) tabs: string[] = [];
  @ContentChildren(TabContentDirective)
  content!: QueryList<TabContentDirective>;
  activeTab = 0;

  get tabsContent() {
    const result = this.content.toArray();

    return result;
  }

  setTab(number: number) {
    this.activeTab = number;
  }
}
